import { useEffect, useState } from "react";
import {
  terminalDualScreenPortion,
  terminalDualScreenBottomMargin,
  terminalDualScreenTopMargin,
} from "./useURLParams.sideEffects";

export default function useDualScreenResize() {
  const [sizes, setSizes] = useState({
    width: 0,
    topMargin: 0,
    bottomMargin: 0,
  });

  useEffect(() => {
    if (terminalDualScreenPortion) {
      setSizes({
        width: terminalDualScreenPortion + "px",
        marginBottom: terminalDualScreenBottomMargin + "px",
        marginTop: terminalDualScreenTopMargin + "px",
      });
    }
  }, []);
  return sizes;
}
